// import * as moment from 'moment'
import moment from 'moment'
import 'moment/locale/fr'
moment.locale('fr')

import { Events } from './events'

class Commons {
  static generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0 // Nombre aléatoire entre 0 et 15
        const v = c === 'x' ? r : (r & 0x3) | 0x8 // Respecte le format UUID
        return v.toString(16) // Convertir en hexadécimal
      },
    )
  }

  static changeToJson(data) {
    return JSON.parse(JSON.stringify(data))
  }

  static contentTransactionTerm(text) {
    const transactionTermRegex =
      /(op.ration)|(transaction)|(retrait)|(d.pot)|(vente)|(achat)/i
    return transactionTermRegex.test(text)
  }

  static setThemeColor(color) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    // if (color == '#fff' || color == '#ffffff') {
    //   Commons.setThemeColor('#efefef')
    // }
    if (window.changeStatusBarColor) window.changeStatusBarColor(color)
    if (window.isIframe) {
      Events.dispatchEvent('iframe_change_status_color', { color })
    }
    const themeColorMetaTag = document.querySelector('[name="theme-color"]')
    if (themeColorMetaTag) {
      themeColorMetaTag.setAttribute('content', color)
      if (themeColorMetaTag.getAttribute('content') !== color)
        Commons.setThemeColor(color)
    }
  }

  static deepClone(obj, visited = new WeakMap()) {
    if (obj === null || typeof obj !== 'object') {
      return obj
    }

    if (visited.has(obj)) {
      return visited.get(obj)
    }

    if (obj instanceof Date) {
      return new Date(obj)
    }

    if (obj instanceof RegExp) {
      return new RegExp(obj)
    }

    const clone = Array.isArray(obj) ? [] : {}

    visited.set(obj, clone)

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'function') {
          clone[key] = obj[key].bind(clone)
        } else {
          clone[key] = Commons.deepClone(obj[key], visited)
        }
      }
    }

    return clone
  }

  static $t(text, type = 'string') {
    const splitedPath = text.split('.')
    let value = textes
    splitedPath.forEach(path => {
      if (!value) return
      value = value[path]
    })
    if (!value && /(boolean)|(number)/.test(value)) return value
    if (typeof value == type) return value
    return '$t' + text
  }

  static arrayOfSize(size) {
    return [...new Array(size)]
  }

  static isEmpty(data) {
    if (/(number)|(boolean)/.test(typeof data)) {
      return false
    }
    if (!data) {
      return true
    }
    if (Array.isArray(data)) {
      return data.length === 0
    }
    const dataProperties = Object.values(data)
    return dataProperties && dataProperties.length == 0
  }

  static timestampToDate(timestamp, dateFormat = 'DD MMMM YYYY') {
    timestamp = `${timestamp}`
    if (timestamp.length == 13)
      timestamp = `${(parseInt(timestamp) || 0) / 1000}`
    if (timestamp == '0') return '-'

    return moment.unix(timestamp).format(dateFormat)
  }

  static time(time, dateFormat = 'DD MMMM YYYY') {
    return moment(new Date(time)).format(dateFormat)
  }

  static timeFrom(time) {
    // const moment2 = moment.updateLocale('fr')
    // console.log(moment2)
    const mm = new moment(time)
    mm.locale('fr')
    return mm.fromNow()
    // return new moment(new Date(time)).fromNow()
  }

  static round(value, decimals = 2) {
    return Number(Math.floor(value + 'e' + decimals) + 'e-' + decimals)
  }

  static copy(text, copiedText) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    try {
      const type = 'text/plain'
      const blob = new Blob([text], { type })
      const data = [new ClipboardItem({ [type]: blob })]
      navigator.clipboard.write(data)
      window.toastNotification('success', text, copiedText)
    } catch (error) {
      window.toastNotification('warning', 'Oups, Impossible de copier ce texte')
    }
  }

  static observeElementVisibility(
    elementOrSelector,
    onVisible = () => {},
    onHidden = () => {},
    onFullVisible = () => {},
  ) {
    let element = elementOrSelector
    if (typeof element == 'string')
      element = document.querySelector(elementOrSelector)
    if (!element) {
      console.log('selector ' + elementSelector + ' not found')
      return
    }
    let isPartiallyVisible = false
    let isFullyVisible = false
    let isHidden = true
    const observer = new IntersectionObserver(
      function (entries) {
        let newIsPartiallyVisible =
          entries[0].intersectionRatio < 1 && entries[0].intersectionRatio > 0
        let newIsFullyVisible = entries[0].intersectionRatio == 1
        let newIsHidden = entries[0].intersectionRatio == 0

        if (
          isPartiallyVisible === newIsPartiallyVisible &&
          isFullyVisible === newIsFullyVisible &&
          isHidden === newIsHidden
        ) {
          return
        }
        isPartiallyVisible = newIsPartiallyVisible
        isFullyVisible = newIsFullyVisible
        isHidden = newIsHidden

        if (isFullyVisible) {
          onVisible()
          onFullVisible()
        } else if (isPartiallyVisible) onVisible()
        else if (isHidden) onHidden()
      },
      { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] },
    )
    observer.observe(element)
    return 'ok'
  }

  static formatCurrency(currency) {
    if (/xof/i.test(currency)) return 'FCFA'
    return currency
  }

  static formatAmount(amount) {
    // Convertir le montant en chaîne de caractères
    let amountStr = amount.toString()

    // Séparer les parties entière et décimale (si nécessaire)
    let parts = amountStr.split('.')
    let integerPart = parts[0]
    let decimalPart = parts.length > 1 ? '.' + parts[1] : ''

    // Ajouter des espaces comme séparateurs de milliers
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

    // Retourner le montant formaté avec "XOF" à la fin
    return integerPart + decimalPart
  }
}

const textes = {}

export { Commons }
